import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsSelectField from "./forms-select-field.vue";
import FormsBaseSelectField from "./_imports/forms-base-select-field.vue";

export default {
	name: 'forms-state-select-field',
	template: getVueTemplate('forms-state-select-field'),
	mixins: [
		FormsBaseSelectField
	],
	components: {
		FormsSelectField
	},
	props: {
		field: Object
	},
	data() {
		return {
			innerField: {},
			isVisible: false,
			selecting: false
		};
	},
	computed: {
		formattedOptions() {
			return this.field.provincesStates.map(state => ({
				text: state.name,
				value: state.englishName
			}));
		}
	},
	watch: {
		isVisible() {
			if (this.isVisible) {
				setTimeout(() => {
					this.innerField.selecting = true;
				}, 0);
			}
		},
		formState() {
			if (this.isEnriched) {
				this.isVisible = false;
				this.ignore = false;
			} else {
				if (this.field.countrySource) {
					this.isVisible = this.formState.formCountry === this.field.countrySource.englishName;
					this.ignore = !this.isVisible;
				}
			}

			this.updateState(state => state.isVisible = this.isVisible);
		}
	},
	methods: {
		onInnerFieldStateUpdate(innerField) {
			this.innerField = innerField;
			this.userInput = this.innerField.userInput;
			this.validateField();
		}
	}
};